import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, ReplaySubject} from 'rxjs';
import {first, map} from 'rxjs/operators';
import {FilterService} from './filter.service';
import {CountedAndPaginated} from '../interface/response/counted-and-paginated';
import {Uuid} from '../interface/response/uuid';
import {CommissionTable, CommissionTableListItem} from '../interface/commission-table';

@Injectable({
  providedIn: 'root'
})
export class CommissionTableService {

  public readonly commissionTableListSubject:
    ReplaySubject<CountedAndPaginated<CommissionTableListItem>>
    = new ReplaySubject<CountedAndPaginated<CommissionTableListItem>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
  ) {
  }

  public create(formData: any): Observable<Uuid> {
    return this.httpClient
      .post('/rest/crm/commission-table', formData)
      .pipe(first()) as Observable<Uuid>;
  }

  public update(
    uuid: string,
    formData: any
  ): Observable<CommissionTable> {
    return this.httpClient
      .put(`/rest/crm/commission-table/${uuid}`, formData)
      .pipe(first()) as Observable<CommissionTable>;
  }

  public get(uuid: string): Observable<CommissionTable> {
    return this.httpClient
      .get(`/rest/crm/commission-table/${uuid}`)
      .pipe(first()) as Observable<CommissionTable>;
  }

  public loadList(
    page: number,
    pageSize: number,
    filters: object
  ): void {
    this.httpClient
      .get(
        `/rest/crm/commission-table?page=${page + 1}&pageSize=${pageSize}&`
        + this.filterService.parseFilters(filters)
      )
      .pipe(first())
      .subscribe(
        (result: CountedAndPaginated<CommissionTableListItem>) => {
          this.commissionTableListSubject.next(result);
        }
      );
  }

  /**
   * Lista do selecta "Tabela źródłowa".
   */
  public getOptions(): Observable<CommissionTableListItem[]> {
    return this.httpClient
      .get<CountedAndPaginated<CommissionTableListItem>>(
        '/rest/crm/commission-table?page=1&pageSize=1000'
      )
      .pipe(
        first(),
        map(result => result.items)
      );
  }
}
